import { qsa } from "./utils.js"

export const initMasonry = () => {
  if (CSS.supports("grid-template-rows", "masonry")) {
    /* Nice, we're done */
    return
  }

  const resize = () => {
    for (const parent of qsa(".masonry")) {
      const style = getComputedStyle(parent)
      const gap = Number.parseInt(style.rowGap, 10)
      const height = Number.parseInt(style.gridAutoRows, 10) + gap

      for (const cell of parent.children) {
        if (cell.matches(".masonry__item")) {
          let cellHeight = gap
          for (const child of cell.children) {
            cellHeight += child.getBoundingClientRect().height
          }
          const span = customRound(cellHeight / height)
          cell.style.gridRowEnd = `span ${span}`
        }
      }
    }
  }

  resize()
  window.addEventListener("resize", resize)
}

/**
 * Rounds a number to the nearest integer based on a custom threshold.
 * If the fractional part is 0.26 or greater, rounds up; otherwise rounds down.
 *
 * @param {number} num - The number to be rounded.
 * @returns {number} - The rounded integer.
 */
const customRound = (num) => {
  const integerPart = Math.floor(num) // Get the integer part
  const fraction = num - integerPart // Calculate the fractional part
  return fraction >= 0.26 ? Math.ceil(num) : integerPart
}
